export default __webpack_public_path__ + "static/media/Resume.06cf3892.pdf";